import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container not-found-view text-center py-5" }
const _hoisted_2 = { class: "h3 mb-3" }
const _hoisted_3 = { class: "text-muted mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t("notFound.title")), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("notFound.message")), 1),
    _createVNode(_component_router_link, {
      to: "/",
      class: "btn btn-primary"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("notFound.home")), 1)
      ]),
      _: 1
    })
  ]))
}